import { CalculosInventario } from 'src/drheranca/types';
import {
  TIPO_DESPESA_INFORMATIVA_LABEL,
  TIPO_ITEM_FORA_ESCOPO_LABEL,
} from '../definitions/dividas';
import { ExcelCellValue, ExcelSheetData } from '../types';

export const DESPESAS_INFORMATIVAS_COLUMNS = [
  'Descrição',
  'Tipo',
  'Data de quitação',
  'Valor (R$)',
] as const;

export const ITENS_FORA_ESCOPO_COLUMNS = [
  'Descrição',
  'Tipo',
  'Motivo',
  'Data de quitação',
  'Valor (R$)',
] as const;

export function buildDespesasInformativasExcelSheet(
  calculos: CalculosInventario,
): ExcelSheetData | null {
  const itens = calculos.despesasInformativas || [];
  if (itens.length === 0) return null;

  const header: ExcelCellValue[] = [...DESPESAS_INFORMATIVAS_COLUMNS];
  const rows: ExcelCellValue[][] = [header];
  itens.forEach((d) => {
    rows.push([
      d.descricao || '—',
      TIPO_DESPESA_INFORMATIVA_LABEL[d.tipo] ?? d.tipo,
      d.data_quitacao || '—',
      d.valor ?? 0,
    ]);
  });
  const total = itens.reduce((s, d) => s + (d.valor || 0), 0);
  rows.push([
    'Total (informativo — não afeta o cálculo)',
    'Despesas já pagas pelos herdeiros, sem dupla contagem com as estimativas do sistema',
    null,
    total,
  ]);

  return {
    rows,
    colWidths: [50, 36, 18, 18],
    valueColumnStart: 3,
  };
}

export function buildItensForaEscopoExcelSheet(
  calculos: CalculosInventario,
): ExcelSheetData | null {
  const itens = calculos.dividasIgnoradas || [];
  if (itens.length === 0) return null;

  const header: ExcelCellValue[] = [...ITENS_FORA_ESCOPO_COLUMNS];
  const rows: ExcelCellValue[][] = [header];
  itens.forEach((d) => {
    rows.push([
      d.descricao || '—',
      TIPO_ITEM_FORA_ESCOPO_LABEL[d.tipo] ?? d.tipo,
      d.motivo || '—',
      d.data_quitacao || '—',
      d.valor ?? 0,
    ]);
  });
  const total = itens.reduce((s, d) => s + (d.valor || 0), 0);
  rows.push([
    'Total (ignorado no cálculo)',
    'Itens fora do escopo deste inventário',
    'Apenas registro histórico',
    null,
    total,
  ]);

  return {
    rows,
    colWidths: [50, 24, 60, 18, 18],
    valueColumnStart: 4,
  };
}
